import { React, useEffect } from "react";
import { Card } from "react-bootstrap";
import AOS from "aos";
import GroupImge from "../../Assets/GroupImgAbout.png";
import OurMisionImg from "../../Assets/ourMission.png";
import OurVisionImg from "../../Assets/ourVision.png";
// import 'bootstrap/dist/css/bootstrap.css';

const Misson = () => {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const contents = [
    {
      id: 1,
      img: OurMisionImg,
      title: "Our Mission",
      content: "Supporting you through digital transformation",
    },
    {
      id: 2,
      img: OurVisionImg,
      title: "Our Vision",
      content:
        "To transform last mile delivery through automation of daily processes",
    },
  ];

  return (
    <div className="container">
      <div
        className="row text-start text-lg-center justify-content-center align-items-center"
        data-aos="fade-right"
      >
        {contents.map((content) => {
          return (
            <Card
              key={content.id}
              className="col-12 col-md-4 justify-content-between border-0 text-center text-lg-start"
            >
              <Card.Body>
                <img
                  src={content.img}
                  alt="Our mision and Vision Images"
                  className="my-3"
                />
                <Card.Title className="fw-bold fs-5">
                  {content.title}
                </Card.Title>
                <Card.Text className="fs-6">{content.content}</Card.Text>
              </Card.Body>
            </Card>
          );
        })}

        <div className="col-12 col-md my-5 my-md-0">
          <img
            src={GroupImge}
            alt="Group In About Us"
            className="img-fluid display-inline"
          />
        </div>
      </div>
    </div>
  );
};

export default Misson;
